/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback } from 'react';
import { debounce } from 'lodash';

const useDebounce = (fnToDebounce: any, durationInMs = 200) => {
  return useCallback(debounce(fnToDebounce, durationInMs), [fnToDebounce, durationInMs]);
};

export default useDebounce;
